import { StringFormat } from "@packages/common";
import type { DealerInfoDTO } from "../dtos";
import type { SearchApiResponseDTO } from "../dtos/api/search-api-response.dto";

export abstract class DealerTransformer {
  static transform(params: SearchApiResponseDTO): DealerInfoDTO | null {
    const { IdRevendedor: dealerId } = params?.FilterCustom || {};
    const {
      Seller: dealerInfo,
      ProductCode: productCode,
      HotDeal,
    } = params?.SearchResults?.[0] || {};

    if (!dealerId || !dealerInfo) return null;

    const sluggedCity = dealerInfo?.City
      ? StringFormat.formatSlug(dealerInfo.City)
      : undefined;

    const abbrState = dealerInfo.State?.split("(")[1]
      ?.replace(")", "")
      .toLocaleLowerCase();

    const sluggedLocation =
      sluggedCity && abbrState ? `${sluggedCity}-${abbrState}` : undefined;

    const dealerSlug = dealerInfo.FantasyName
      ? `${StringFormat.formatSlug(dealerInfo.FantasyName)}-${dealerId}`
      : null;

    return {
      id: dealerInfo.Id,
      productCode,
      sellerType: dealerInfo.SellerType,
      city: dealerInfo.City,
      state: dealerInfo.State,
      sluggedCity,
      abbrState,
      sluggedLocation,
      dealerSlug,
      adType: {
        id: dealerInfo.AdType?.id,
        value: dealerInfo.AdType?.Value,
      },
      budget: dealerInfo.BudgetInvestimento,
      dealerScore: dealerInfo.DealerScore,
      carDelivery: dealerInfo.CarDelivery,
      tradeWithChange: dealerInfo.TrocaComTroco,
      exceededPlan: dealerInfo.ExceededPlan,
      fantasyName: dealerInfo.FantasyName,
      localization: dealerInfo.Localization?.map((item) => ({
        state: item.State,
        city: item.City,
        country: item.Country,
        neighborhood: item.Neighborhood,
        zipCode: item.ZipCode,
        abbrState: item.AbbrState,
      })),
      hotDeal:
        HotDeal?.map((deal) => ({
          id: deal.Id || "",
          value: deal.Value || "",
        })) || null,
    };
  }
}
